import Loading from '../../../Common/Loading';
import { useSpecialCareChartsDataContext } from './hooks/useSpecialCareChartsDataContext';
import { SpecialCares } from './SpecialCares';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useSpecialCareChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <SpecialCares />
            </div>
        </>
    );
};
